import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Polyfills that are currently not configured via babel
import 'whatwg-fetch'
import 'document-register-element/build/document-register-element'
import 'intl'

import 'mutationobserver-shim'
import Vue from 'vue'
import '@/plugins/bootstrap-vue'
import '@/mixins/import'
import { register as registerCustomElements } from '@/helper/customElementsHelper'
import * as Store from '@/store'
import vueCustomElement from 'vue-custom-element'
import { createProvider } from '@/apollo'

import DynSlot from '@/components/generic/DynSlot'
import Tooltip from '@/components/generic/Tooltip'

import Config from '../config/bild'
import { globalStoreConfig } from '@/store/config'
import { storeConfig } from '@/store/config/bild'

import CurrentMsisdn from '@/components/process/generic/Customer/Msisdn/CurrentMsisdn'
import CurrentCustomer from '@/components/process/generic/Customer/CurrentCustomer'
import LoginComponent from '@/components/process/generic/Authentication/Login/LoginComponent'
import LogOutLink from './components/process/generic/Authentication/LogOut/LogOutLink'
import CurrentTariff from './components/process/generic/Tariff/generic/CurrentTariff/CurrentTariff'
import TeaserText from '@/components/generic/TeaserText'
import BalanceInfo from './components/process/generic/Balance/BalanceInfo'
import GDPRDataWrapper from './components/process/generic/GDPRData/GDPRDataWrapper'
import ConsentWrapper from './components/process/generic/Consent/ConsentWrapper'
import MessageView from '@/components/generic/MessageView/MessageList'
import ActivationWrapper from '@/components/process/BILD/Activation/Wrapper/ActivationWrapper.vue'
import ItemisedBillsOverview from '@/components/process/generic/ItemisedBills/rossmann/ItemisedBillsOverview'
import TariffStatus from '@/components/process/generic/Tariff/bild/TariffStatus'
import EmptyComponent from '@/components/process/generic/Notification/EmptyComponent'
import ConsumptionItemProgress from '@/components/process/generic/Consumption/bild/ConsumptionItemProgress'
import PersonalDataWrapper from '@/components/process/generic/PersonalData/bild/PersonalDataWrapper'
import ChangePaymentWrapper from './components/process/generic/Payment/ChangePayment/bild/ChangePaymentWrapper'
import SendVerificationMail from './components/process/generic/PersonalData/bild/SendVerificationMail'
import OppwaCC from './components/generic/OppwaCC'
import SingleTopUpWrapper from './components/process/generic/TopUp/SingleTopUp/bild/SingleTopUpWrapper'
import CheckSimCard from '@/components/process/generic/SimCard/CheckSimCard/View'
import VoucherTopUpWrapper from './components/process/generic/TopUp/Voucher/VoucherTopUpWrapper'
import ChangeAutoTopUpWrapper from '@/components/process/generic/TopUp/ChangeAutoTopUp/bild/ChangeAutoTopUpWrapper'
import TariffOptionsWrapper from './components/process/generic/Tariff/bild/TariffOptionsWrapper'
import ChangePasswordWrapper from '@/components/process/generic/Password/ChangePassword/bild/ChangePasswordWrapper'
import EmailConfirmationWrapper from '@/components/process/generic/Email/EmailConfirmation/EmailConfirmationWrapper'
import ForgotPasswordWrapper from '@/components/process/generic/Password/ForgotPassword/ForgotPasswordWrapper'
import ResetPasswordConfirmationWrapper from '@/components/process/generic/Password/ResetPassword/ResetPasswordConfirmationWrapper'
import MnpOutStatus from '@/components/process/generic/Mnp/MnpOutStatus/ShowMnpOutStatus'
import CancellationWrapper from '@/components/process/generic/Cancellation/CancellationWrapper'
import ContractSummary from '@/components/process/generic/Tariff/generic/ContractSummary'
import CustomerDocumentListOverview from '@/components/process/generic/CustomerDocumentList/CustomerDocumentListOverview.vue'
import CustomerDocumentBanner from '@/components/process/generic/CustomerDocumentList/CustomerDocumentBanner.vue'

const API_BASE_URL = process.env.VUE_APP_BILD_API_BASE_URL || process.env.VUE_APP_API_BASE_URL
const GRAPHQL_HTTP = process.env.VUE_APP_BILD_GRAPHQL_HTTP || process.env.VUE_APP_GRAPHQL_HTTP

Vue.use(Config, {
  apiUrl: API_BASE_URL
})

const store = Store.createStore({
  ...globalStoreConfig,
  ...storeConfig
})
store.commit('selectBrand', 'bild')
store.commit('selectRetailerId', '60007371')
store.commit('selectType', 'DELIVERY')
// ggf. hier auf ENVs gehen, wenn nötig -> process.env.BILD_CLIENT_ID + BILD_CLIENT_SECRET
store.commit('selectClient', { id: 'bild', secret: 'bild' })
store.commit('selectBaseUrl', API_BASE_URL)

const apolloProvider = createProvider(store, {
  autoLogoutMessage: 'Es ist ein technischer Fehler aufgetreten. Sie wurden zur Sicherheit abgemeldet. Bitte melden Sie sich erneut an. Sollten die Probleme bestehen bleiben, so wenden Sie sich an die Hotline.',
  httpEndpoint: GRAPHQL_HTTP,
  restEndpoint: API_BASE_URL
})

Vue.component('dyn-slot', DynSlot)

Vue.config.productionTip = false

Vue.config.ignoredElements = [
  // Use a `RegExp` to ignore all elements that start with "ion-"
  // 2.5+ only
  // /^ion-/
]

Vue.use(vueCustomElement)
Vue.component('FriendNotification', EmptyComponent)
Vue.component('ConsumptionItem', ConsumptionItemProgress)
Vue.component('dyn-slot', DynSlot)

registerCustomElements({
  // generics
  'app-tooltip': Tooltip,
  'app-teaser-text': TeaserText,
  'app-message-view': MessageView,
  'app-current-msisdn': CurrentMsisdn,
  'app-current-customer': CurrentCustomer,
  'app-current-tariff': CurrentTariff,
  'app-tariff-status': TariffStatus,
  // processes
  'app-activation': ActivationWrapper,
  'app-login': LoginComponent,
  'app-logout': LogOutLink,
  'app-oppwa': OppwaCC,
  'app-balance-info': BalanceInfo,
  'app-consent-wrapper': ConsentWrapper,
  'app-send-verification-mail': SendVerificationMail,
  'app-change-personal-data-wrapper': PersonalDataWrapper,
  'app-gdpr-data-wrapper': GDPRDataWrapper,
  'app-itemised-bills-overview': ItemisedBillsOverview,
  'app-change-payment-wrapper': ChangePaymentWrapper,
  'app-check-sim-card': CheckSimCard,
  'app-single-top-up-wrapper': SingleTopUpWrapper,
  'app-tariff-options-wrapper': TariffOptionsWrapper,
  'app-voucher-top-up-wrapper': VoucherTopUpWrapper,
  'app-change-password-wrapper': ChangePasswordWrapper,
  'app-forgot-password-wrapper': ForgotPasswordWrapper,
  'app-reset-password-confirmation-wrapper': ResetPasswordConfirmationWrapper,
  'app-email-confirmation-wrapper': EmailConfirmationWrapper,
  'app-change-auto-top-up-wrapper': ChangeAutoTopUpWrapper,
  'app-mnp-out-status': MnpOutStatus,
  'app-cancellation-wrapper': CancellationWrapper,
  'app-contract-summary': ContractSummary,
  'app-customer-document-list-overview': CustomerDocumentListOverview,
  'app-customer-document-banner': CustomerDocumentBanner
}, store, apolloProvider)
